// src/components/singalong/ExportPreview.js
//
// The preview player under "Make video" in the Sing-along and Lesson video
// studios.
//
// A <video> that can't play its file shows a grey box and a play button that
// does nothing, and says nothing about why. This one listens for the error and
// says it in words, plus which format the file was recorded in, so a bad file
// is never mistaken for a slow one.

import React, { useEffect, useState } from "react";

const reasonOf = (video) => {
  const e = video?.error;
  if (!e) return "The browser couldn't play this file.";
  const kinds = {
    1: "Loading was stopped.",
    2: "A network error stopped it loading.",
    3: "The browser couldn't decode it (the video data is in a form it can't read).",
    4: "The browser doesn't support this file's format.",
  };
  return `${kinds[e.code] || "The browser couldn't play this file."}${e.message ? ` (${e.message})` : ""}`;
};

const ExportPreview = ({ url, label = "" }) => {
  const [problem, setProblem] = useState("");

  // A new recording gets a fresh chance.
  useEffect(() => setProblem(""), [url]);

  if (!url) return null;

  return (
    <>
      <video
        key={url}
        src={url}
        controls
        playsInline
        preload="metadata"
        className="sa-export-video"
        onError={(e) => setProblem(reasonOf(e.currentTarget))}
      />
      {label && !problem && <p className="sa-muted">Recorded as {label}. Checked: it plays.</p>}
      {problem && (
        <div className="sa-banner tone-red" style={{ marginTop: 10 }}>
          <strong>This preview won’t play.</strong> {problem} Don’t save it to SBL — press{" "}
          <strong>Make video</strong> again.
        </div>
      )}
    </>
  );
};

export default ExportPreview;
